const MEETING_STATUS = {
    EN_EJECUCION: 1,
    ABIERTA: 2,
    FINALIZADA: 3,
    CANCELADA: 4,
}
const CLASSIFICATIONS = {
    DECISION: 1,
    ACCION: 2,
    INFORMACION: 3,
  }
  
const STATUS_POINT = {
  ABIERTO: 1,
  REAGENDADO: 2,
  SUSPENDIDO: 3,
  CERRADO: 4,
}

const AGREEMENTS = {
  EN_BLANCO_DECISION: 1,
  APROBADO_DECISION: 2,
  NO_APROBADO_DECISION: 3,
  DIFERIDO_DECISION: 4,
  EN_BLANCO_ACCION: 5,
  CON_ACUERDO_ACCION: 6,
  SIN_ACUERDO_ACCION: 7,
  DIFERIDO_ACCION: 8,
  NO_APLICA_INFO: 9
}

const POINT_TYPES = {
  ESTANDAR: 1,
  NUEVO: 2,
}

export { MEETING_STATUS, CLASSIFICATIONS, STATUS_POINT, AGREEMENTS, POINT_TYPES }